var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message",class:{patient: _vm.fromPatient},attrs:{"title":_vm.datetime}},[_c('p',{staticClass:"Paragraph1"},[_vm._v(_vm._s(_vm.message.msg))]),_c('p',{staticClass:"Label1 gray-400"},[_vm._v(_vm._s(_vm.formattedTime))])])}
var staticRenderFns = []

export { render, staticRenderFns }